var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 100,
    viewBox: "0 0 280 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    y: 60,
    fontFamily: "Roboto, sans-serif",
    fontSize: 60,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#FF5252"
  }, "Tis"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#213A57",
    dx: -16
  }, "radar"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a6ac8859b636b7ccf9974c5d9057021e.svg";
export { ForwardRef as ReactComponent };